export const blockedOptionMessage = 'Opção Desabilitada';

export const selectMessage = 'Selecionar uma opção';

export const mapTemplate = (template) => {
    return template
        ? { value: template.id, label: template.nome }
        : null;
}
